import api from './http'

/* *****연결사이트 FRONT API***** */

// 연결사이트
const getConnectionSite = (connectionSiteLevel) => {
  return api.getPromise('GET', `/api/connection-site/${connectionSiteLevel}`)
}

export default {
  getConnectionSite,
}
